/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { RouteObject } from 'react-router'
import { LoaderFunctionArgs } from 'react-router-dom'
import LeaseFormPage from './LeaseFormPage'
import LeaseInterventionListPage from './LeaseInterventionListPage'
import LeaseInvoiceListPage from './LeaseInvoiceListPage'
import LeaseListPage from './LeaseListPage'
import LeaseManagementReportListPage from './LeaseManagementReportListPage'
import LeaseRentalReportListPage from './LeaseRentalReportListPage'
import LeaseTemplateFormPage from './template/LeaseTemplateFormPage'
import LeaseTemplateListPage from './template/LeaseTemplateListPage'
import RouteLoaderData from '../../../../client/js/components/RouteLoaderData'
import { fetchLease } from '../../lib/rest/leaseAPIClient'

function leaseLoader (args: LoaderFunctionArgs) {
  const { params } = args
  return fetchLease(Number(params.id))
}

export const leaseRoutes: RouteObject[] = [
  {
    index: true,
    element: <LeaseListPage />
  },
  {
    path: 'create',
    element: <LeaseFormPage />
  },
  {
    path: ':id/*',
    element: <RouteLoaderData
      queryKey={['lease']}
      loader={leaseLoader}
    />,
    children: [
      {
        path: 'edit',
        element: <LeaseFormPage />
      },
      {
        path: 'interventions',
        element: <LeaseInterventionListPage />
      },
      {
        path: 'invoices',
        element: <LeaseInvoiceListPage />
      },
      {
        path: 'management-reports',
        element: <LeaseManagementReportListPage />
      },
      {
        path: 'rental-reports',
        element: <LeaseRentalReportListPage />
      }
    ]
  },
  {
    path: 'templates',
    element: <LeaseTemplateListPage />
  },
  {
    path: 'templates/create',
    element: <LeaseTemplateFormPage />
  },
  {
    path: 'templates/:id/edit',
    element: <LeaseTemplateFormPage />
  }
]
